import { inject } from '@angular/core';
import { ApiServerService } from '../api';

export interface IpInfo {
  ip: string;
}

/**
 * Inyecta una utilidad para obtener información de la IP del cliente
 * a través de la Cloud Function `utils/getIpInfo`.
 *
 * @example
 * const { getIpInfo } = injectIpInfo();
 * const ipInfo = await getIpInfo();
 */
export function injectIpInfo() {
  const apiServer = inject(ApiServerService);

  return {
    getIpInfo: (): Promise<IpInfo> =>
      apiServer.call<IpInfo>('utils/getIpInfo', {})
  };
}
